import React from 'react'

import { TabelaColuna } from 'src/componentes'

export const colunaNomeProfessor = (): TabelaColuna => ({
  Chave: 'nomeProfessor',
  ComOrdenacao: true,
  RenderizarCabecalho: () => <div style={{ width: 200 }}>Nome Professor</div>
})
